module.exports = __webpack_public_path__ + "h5/img/live-logo.5fe49eb4.gif";